<template>
  <div id="app">
    <Navigation v-if="isAuthenticated" />
    <main class="container mx-auto px-4 py-8">
      <router-view />
    </main>
  </div>
</template>

<script lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Navigation from './components/TopNavigation.vue';
import { useAuthStore } from './stores/auth';

export default {
  name: 'App',
  components: {
    Navigation,
  },
  setup() {
    const route = useRoute();
    const authStore = useAuthStore();

    const isAuthenticated = computed<boolean>(() => {
      return authStore.isAuthenticated
             && route.name !== 'Login'
             && route.name !== 'Register'
             && route.name !== 'ProfileSetup';
    });

    return {
      isAuthenticated,
    };
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  background-color: #f9fafb;
}
</style>
